import { render, staticRenderFns } from "./ModalItemsPreventiva.vue?vue&type=template&id=fe609a92&scoped=true&"
import script from "./ModalItemsPreventiva.vue?vue&type=script&lang=js&"
export * from "./ModalItemsPreventiva.vue?vue&type=script&lang=js&"
import style0 from "./ModalItemsPreventiva.vue?vue&type=style&index=0&id=fe609a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe609a92",
  null
  
)

export default component.exports